export class SystemConstants {
  public static CURRENT_USER = "CURRENT_USER";
  public static REMOTE_CURRENT_USER = "REMOTE_CURRENT_USER";

  // public static BASE_API = "http://localhost:5005/api/";
  // public static BASE_API_IMG = "http://localhost:5005/";
  // public static BASE_URL = "http://localhost:4200";

  public static BASE_API = "https://api.vananhfabric.com/api/";
  public static BASE_API_IMG = "https://api.vananhfabric.com/";
  public static BASE_URL = "https://phanmem.vananhfabric.com";

  // public static BASE_URL_ASSETS = "http://localhost:4200/assets/img/";

  // public static BASE_API = "https://115.78.231.164:8989/api/";
  // public static BASE_API_IMG = "https://115.78.231.164:8989/";
  // public static BASE_URL = "http://115.78.231.164:9000";
  // public static BASE_URL_ASSETS = "http://115.78.231.164:9000/assets/img/";

  // public static BASE_API = "http://115.78.231.164:8989/api/";
  // public static BASE_API_IMG = "http://115.78.231.164:8989/";
  // public static BASE_URL = "http://115.78.231.164:9000";
  // public static BASE_URL_ASSETS = "http://115.78.231.164:9000/assets/img/";

  // public static BASE_API = "https://www.imartvietnam.com:9999/api/";
  // public static BASE_API_IMG = "https://www.imartvietnam.com:9999/";
  // public static BASE_URL = "http://115.78.231.164:9000";
  // public static BASE_URL_ASSETS = "http://115.78.231.164:9000/assets/img/";
}
